export function getUrlWithoutQueryParams(url: string): string[] {
  const index = url.indexOf("?");
  if (index === -1) {
    return [url];
  }
  return [url.substring(0, index), url.substring(index)];
}
